import { QueryClientProvider } from '@tanstack/react-query';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { createI18n, isSupportedLocale } from '@nokowazzi/i18n';
import { initAnalytics } from './lib/analytics';
import { queryClient } from './lib/query-client';
import { initSentry } from './lib/sentry';
import { startAuthListener } from './stores/auth';
import { routeTree } from './routeTree.gen';
import './styles.css';

initSentry();
initAnalytics();

const deviceLang = navigator.language.slice(0, 2);
const i18n = createI18n({ lng: isSupportedLocale(deviceLang) ? deviceLang : 'ko' });
document.documentElement.lang = i18n.language;

startAuthListener();

const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </I18nextProvider>
  </StrictMode>,
);
